export default {
    excess: 'Вишок одговорност',
    security: 'Депозит за безбедност',
    fuel_policy: 'Политика за гориво',
    like_for_like: 'Исто за исто',
    full_to_full: 'Полн до полн',
    mileage: 'Километража: {mileage} милји по наем',
    unlimited_mileage: 'Неограничена километража',
    non_refundable: 'Неповратливо',
    free_cancellation_until: 'Бесплатно откажување до {date}',
    cancellation_with_terms: 'Откажување {0} согласно ',
    t_c_text: 'Правила и услови',
    two_free_extras: 'Два бесплатни додатоци при преземање',
    glass_tyres_covered: 'Стакло и гуми се покриени',
    spec_fuel_petrol: 'бензин',
    spec_fuel_petrol_diesel: 'бензин/дизел',
};
